import {Workspace} from "@/domains/-workspace/models/Workspace.ts";

const WORKSPACE_ORDER_ID = 'workspace_order';

export function loadWorkspaceOrder(): number[] | null {
  const content = localStorage.getItem(WORKSPACE_ORDER_ID);
  if (!content) return null;
  try {
    return JSON.parse(content);
  } catch (error) {
    localStorage.removeItem(WORKSPACE_ORDER_ID);
    return null;
  }
}

export function saveWorkspaceOrder(workspaces: Workspace[]): void {
  const data = JSON.stringify(workspaces.map(workspace => workspace.id));
  localStorage.setItem(WORKSPACE_ORDER_ID, data);
}
